/**
 * How the maintenance panel groups its jobs.
 *
 * Shared because both sides need the same list and neither can own it: the job
 * registry on the server tags each job with a category, and the panel builds its
 * tab bar from the same array. Two copies would let a job be filed under a tab
 * that does not exist, which renders as an empty group with no explanation.
 */
export const MAINTENANCE_CATEGORIES = [
  { id: "integrations", label: "Integrations" },
  { id: "content", label: "Content & media" },
  { id: "data", label: "Data integrity" },
] as const;

export type MaintenanceCategory = (typeof MAINTENANCE_CATEGORIES)[number]["id"];
